import Note from '../../src/legacy/Note';
export default Note;
